// extracted by mini-css-extract-plugin
module.exports = {"player":"VideoPlayer_player__vL_QG","reactPlayer":"VideoPlayer_reactPlayer__3DmMM","playButton":"VideoPlayer_playButton__1_YU1"};